/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const overlayNoRowsTemplate = 'There are no records to display.';

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: false,
        filter: false,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/transaction-log?ordernumber=${params.value}`}>{params.value}</Link> );

        }
    },
    {
        field: 'activityType',
        headerName: 'Activity Type',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'dealerRespCode',
        headerName: 'Dealer Resp Code',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'factoryRespCode',
        headerName: 'Factory Resp Code',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'transDate',
        headerName: 'Trans Date',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'transTime',
        headerName: 'Trans Time',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = new Date( params.value ).toLocaleString( 'en-US', {
                hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true
            } );
            return ( <span>{dt}</span> );

        }
    }
];

const OpenActivityTable = props => (

    <section className="atp-search-result-panel order-open-activity-result-panel">
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
                overlayNoRowsTemplate={overlayNoRowsTemplate}
            />
        </div>

    </section>
);

OpenActivityTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default OpenActivityTable;
